import React from 'react';
import { Box, Typography, Paper, Button } from '@mui/material';
import DescriptionIcon from '@mui/icons-material/Description';
import MainLayout from '@/components/MainLayout';

const ReportCard = ({ title, description, iconColor = 'primary' }) => {
  const buttonColor = ['primary', 'secondary', 'warning', 'error', 'info', 'inherit'].includes(iconColor)
    ? iconColor
    : 'inherit';
  return (
    <Paper
      variant="outlined"
      sx={{
        p: 4,
        textAlign: 'center',
        height: '100%',
        '&:hover': { borderColor: 'primary.main' },
      }}
    >
      <DescriptionIcon sx={{ fontSize: 48, mb: 2 }} color={iconColor} />
      <Typography variant="h6" gutterBottom>
        {title}
      </Typography>
      <Typography color="text.secondary" variant="body2" sx={{ mb: 3 }}>
        {description}
      </Typography>
      <Button size="small" color={buttonColor} variant="outlined">
        Open →
      </Button>
    </Paper>
  );
};

const ReportsPage = () => {
  return (
    <MainLayout>
      <Box sx={{ maxWidth: 1200, mx: 'auto' }}>
        <Typography variant="h3" color="primary" gutterBottom>
          Reports
        </Typography>
        <Typography color="text.secondary" variant="body2" sx={{ mb: 4 }}>
          Analytics & insights
        </Typography>
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: { xs: '1fr', md: 'repeat(2, 1fr)' },
            gap: 3,
          }}
        >
          <ReportCard title="Members export" description="Export all member data to CSV" iconColor="primary" />
          <ReportCard title="Appointments export" description="Export booking history to CSV" iconColor="secondary" />
          <ReportCard title="Revenue report" description="Financial summary and trends" iconColor="warning" />
          <ReportCard title="Attendance report" description="No-shows and attendance tracking" iconColor="action" />
        </Box>
      </Box>
    </MainLayout>
  );
};

export default ReportsPage;
